import React from 'react';
import {
  Button,
  ButtonToolbar,
  Radio,
  RadioGroup,
  Modal,
  Divider,
} from 'rsuite';
import KubondModalCard from './KubondModalCard';
import KubondChart from './KubondChart';

const styles = {
  radioGroupLabel: {
    padding: '8px 12px',
    display: 'inline-block',
    verticalAlign: 'middle',
  },
};

const KubondModal = () => {
  const [open, setOpen] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState('static');
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="modal-container">
      <RadioGroup
        name="radioList"
        appearance="picker"
        inline
        value={backdrop}
        onChange={(value) => setBackdrop(value)}
      >
        <span style={styles.radioGroupLabel}>Backdrop: </span>
        <Radio value="static">static</Radio>
        <Radio value={true}>true</Radio>
        <Radio value={false}>false</Radio>
      </RadioGroup>
      <hr />
      <ButtonToolbar>
        <Button onClick={handleOpen}> Open</Button>
      </ButtonToolbar>

      <Modal
        backdrop={backdrop}
        keyboard={false}
        open={open}
        onClose={handleClose}
        autoFocus
      >
        <Modal.Header>
          <Modal.Title>AMC Kubond</Modal.Title>
        </Modal.Header>
        <br />
        <KubondModalCard />
        <Modal.Body>
          <h5>About</h5>
          The best part of AMC’s recent bond offering is that the company now
          has more working capital. This bond offering will allow AMC, for
          example, to refinance the high-interest notes that it took out during
          the height of the pandemic.{' '}
          <a href="https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad?hl=en">
            read more
          </a>
          <Divider />
          <h5>Return Insights</h5>
          <KubondChart />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="primary">
            Ok
          </Button>
          <Button onClick={handleClose} appearance="subtle">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KubondModal;
